import React from 'react';
import once from 'lodash/once';
const createContext = once(() => React.createContext({}));
export const useCreateSearchContext = () => createContext();
